import React, { useState, useEffect, useContext } from 'react';
// design
import { Modal, Table, Divider, Badge, Card } from 'antd';
// method
import { getMethod, postMethod } from '../services/methods';
// utils
import {dateFormat, isGreatThanNow} from '../utils/dateFormat';
// context
import { GlobalContext } from "../context/globalContext";
import DatePicker from "react-datepicker";
import * as dayjs from "dayjs";

function TaskDialog({ visible, onCancel, taskUser, onCreate }) {
    // context
    const { contextData } = useContext(GlobalContext);

    const [data, setData] = useState(null);

    const today = new Date();
    const [startDate, setStartDate] = useState(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7));
    const [endDate, setEndDate] = useState(new Date());

    async function fetchData() {
        if (visible) {
            const userData = await getMethod(`/person/1000/0/`,
                {
                    state: taskUser.state,
                    county: taskUser.county,
                    startDate: dayjs(startDate).format('YYYY/MM/DD'),
                    endDate: dayjs(endDate).format('YYYY/MM/DD'),
                });

            setData(userData.list)
        }
    }

    useEffect(() => {
        fetchData();
    }, [visible])

    useEffect(() => {
        fetchData();
    }, [startDate, endDate])

    const columns = [
        {
            title: 'Doğum günü',
            dataIndex: 'birthday',
            key: 'birthday',
            width: '120px',
            render: (value, row, index) => {
                const date = dateFormat(value);
                return date;
            },
        },
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name',
            width: "120px"
        },
        {
            title: 'Soyad',
            dataIndex: 'surname',
            key: 'surname',
            width: "120px"
        },
        {
            title: 'Tel',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'İl',
            dataIndex: 'state',
            key: 'state',
            width: "100px"
        },
        {
            title: 'İlçe',
            dataIndex: 'county',
            key: 'county',
            width: "100px"
        },
        {
            title: 'Mahalle',
            dataIndex: 'district',
            key: 'district',
            width: "100px"
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address',
        }
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys)
            setSelectedRows(selectedRows)
        },
        getCheckboxProps: (record) => ({
            disabled: record.engagement.length > 0 && record.engagement
                .filter(item => isGreatThanNow(item.expiration_date))
                .length > 0,
            name: record.name,
        }),
    };

    const setTask = async() => {
        const mapRowData = selectedRows.reverse().map(item => (
            {
                created_at: new Date(),
                expiration_date: +new Date() + 1000 * 60 * 60 * 24,
                assigned_by: contextData.userData._id,
                assigned_to: taskUser._id,
                birthday_user: item._id,
                state: item.state,
                county: item.county,
                state_user: contextData.userData.stateUser,
                county_user: contextData.userData.countyUser,
            }
        ))
        postMethod(`/task`, mapRowData);
        fetchData();
        setSelectedRowKeys([]);
        onCreate();
    }

    return (
        <Modal
            visible={visible}
            title="Görev atama"
            okText="Atama yap"
            cancelText="İptal"
            onCancel={onCancel}
            width="95%"
            onOk={() => { setTask(); }}
        >
            <div style={{display: "flex", marginBottom: 10}}>
                <div style={{marginRight: 5}}>Başlangıç Zamanı:</div>
                <div>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}/>
                </div>
                <div style={{marginLeft: 20, marginRight: 5}}>Bitiş Zamanı:</div>
                <div>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                    />
                </div>
            </div>
            <Table
                rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                }}
                scroll={{ y: 400 }}
                loading={!data}
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={data}
                pagination={false}
                expandable={{
                    expandedRowRender: record =>
                        record.engagement.map((item, index) => (
                            <Badge.Ribbon key={index} text={item?.is_completed ? "Tamamlandı" : "Tamamlanmadı"} color={!item?.is_completed && "red"}>
                                <Card style={{ marginBottom: "16px" }}>
                                    <Divider>{dateFormat(item?.created_at)} Tarihli Görev</Divider>
                                    <p>{dateFormat(item?.expiration_date)} tarihinde görev sona eriyor.</p>
                                    <h4>Atanan Kişi</h4>
                                    <p style={{ margin: 0 }}>{item?.assigned_to?.name} {item?.assigned_to?.surname} {item?.assigned_to?.phone}</p>
                                    <br />
                                    <h4>Atayan Kişi</h4>
                                    <p style={{ margin: 0 }}>{item?.assigned_by?.name} {item?.assigned_by?.surname} {item?.assigned_by?.phone}</p>
                                </Card>
                            </Badge.Ribbon>
                        ))
                    ,
                    rowExpandable: record => record.engagement.length > 0,
                }}
            />

        </Modal>
    );
};

export default TaskDialog;
